export const getCursorPosition = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const selectionEnd = (event.nativeEvent.target as HTMLInputElement)
    ?.selectionEnd;
  const selectionStart = (event.nativeEvent.target as HTMLInputElement)
    ?.selectionStart;

  if (selectionEnd === null || selectionStart === null) {
    return undefined;
  }

  if (selectionEnd === selectionStart) {
    return selectionEnd;
  }

  return undefined;
};
